import { render, staticRenderFns } from "./BeatButton.vue?vue&type=template&id=fd8f80a4&scoped=true"
import script from "./BeatButton.vue?vue&type=script&lang=js"
export * from "./BeatButton.vue?vue&type=script&lang=js"
import style0 from "./BeatButton.vue?vue&type=style&index=0&id=fd8f80a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8f80a4",
  null
  
)

export default component.exports